export const OPTION_LIST_01234 = [
    { label: 'Mai', value: '0' },
    { label: 'Quasi mai', value: '1' },
    { label: 'A volte', value: '2' },
    { label: 'Abbastanza spesso', value: '3' },
    { label: 'Molto spesso', value: '4' }
]

export const OPTION_LIST_43210 = [
    { label: 'Mai', value: '4' },
    { label: 'Quasi mai', value: '3' },
    { label: 'A volte', value: '2' },
    { label: 'Abbastanza spesso', value: '1' },
    { label: 'Molto spesso', value: '0' }
]

export const DOMANDE = [
    {
        label: '1. Nell’ultimo mese, con che frequenza si è sentito fuori di sé poiché è avvenuto qualcosa di inaspettato?',
        name: 'ps1',
        optionList: OPTION_LIST_01234
    },
    {
        label: '2. Nell’ultimo mese, con che frequenza ha avuto la sensazione di non essere in grado di avere controllo sulle cose importanti della sua vita?',
        name: 'ps2',
        optionList: OPTION_LIST_01234
    },
    {
        label: '3. Nell’ultimo mese, con che frequenza si è sentito nervoso o “stressato”?',
        name: 'ps3',
        optionList: OPTION_LIST_01234
    },
    {
        label: '4. Nell’ultimo mese, con che frequenza si è sentito fiducioso sulla sua capacità di gestire i suoi problemi personali?',
        name: 'ps4',
        optionList: OPTION_LIST_43210
    },
    {
        label: '5. Nell’ultimo mese, con che frequenza ha avuto la sensazione che le cose andassero come diceva lei?',
        name: 'ps5',
        optionList: OPTION_LIST_43210
    },
    {
        label: '6. Nell’ultimo mese, con che frequenza ha avuto la sensazione di non riuscire a star dietro a tutte le cose che doveva fare?',
        name: 'ps6',
        optionList: OPTION_LIST_01234
    },
    {
        label: '7. Nell’ultimo mese, con che frequenza ha avvertito di essere in grado di controllare ciò che la irrita nella sua vita?',
        name: 'ps7',
        optionList: OPTION_LIST_43210
    },
    {
        label: '8.Nell’ultimo mese, con che frequenza ha sentito di padroneggiare la situazione?',
        name: 'ps8',
        optionList: OPTION_LIST_43210
    },
    {
        label: '9.Nell’ultimo mese, con che frequenza è stato arrabbiato per cose che erano fuori dal suo controllo?',
        name: 'ps9',
        optionList: OPTION_LIST_01234
    },
    {
        label: '10. Nell’ultimo mese, con che frequenza ha avuto la sensazione che le difficoltà si stavano accumulando a un punto tale per cui non poteva superarle?',
        name: 'ps10',
        optionList: OPTION_LIST_01234
    }
]